import React, { useMemo, useState } from 'react';

import { useSortedItems } from 'hooks/useSorting';
import PropTypes from 'prop-types';

import { BasicTable } from 'components/DebFormComponents/Table/BasicTable';
import { CustomTableHeader } from 'components/DebFormComponents/Table/CustomTableHeader';
import { SubAccountTableRows } from 'components/SubAccounts/SubAccountTableRows';
import { SubAccountsPopup } from 'components/SubAccounts/SubAccountsPopup';

import { EIV_STATUS_SALES_FORCE, POPUP_TYPE } from 'global/constants';

export const SubAccountsTable = ({ data, experts, fetchExperts }) => {
  const [sortedRows, sortConfig, setSortConfig, updateSorting] = useSortedItems(data);
  const [selectedId, setSelectedId] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const selectedExpert = useMemo(
    () => data?.find((item) => item?.id === selectedId),
    [data, selectedId]
  );

  const headers = [
    <CustomTableHeader
      key="completeName"
      title="Name"
      updateKey="completeName"
      sortingObject={sortConfig}
      updateSorting={updateSorting}
    />,
    <CustomTableHeader
      key="netzportalEmail"
      title="E-Mail-Adresse"
      updateKey="netzportalEmail"
      sortingObject={sortConfig}
      updateSorting={updateSorting}
    />,
    <CustomTableHeader
      key="salesForceStatus"
      title="Status"
      updateKey="salesForceStatus"
      sortingObject={sortConfig}
      updateSorting={updateSorting}
    />,
    <CustomTableHeader key="action" sorting={false} />,
  ];

  return (
    <div>
      <BasicTable
        headers={headers}
        rows={
          <SubAccountTableRows
            rows={sortedRows}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            setOpenPopup={setOpenPopup}
          />
        }
      />
      <SubAccountsPopup
        isOpen={openPopup}
        selectedExpert={selectedExpert}
        onClose={() => {
          setOpenPopup(false);
          if (typeof fetchExperts === 'function') fetchExperts();
        }}
        experts={experts}
        forcePopupType={
          [EIV_STATUS_SALES_FORCE.ACTIVE, EIV_STATUS_SALES_FORCE.IN_PROGRESS].includes(
            selectedExpert?.salesForceStatus
          )
            ? POPUP_TYPE.DELETE
            : undefined
        }
      />
    </div>
  );
};

SubAccountsTable.propTypes = {
  data: PropTypes.array.isRequired,
  experts: PropTypes.array.isRequired,
  fetchExperts: PropTypes.func,
};
SubAccountsTable.defaultProps = {
  fetchExperts: undefined,
};
